import { Injectable } from '@angular/core';
import { setActiveAccount } from '@epicuro-next/state/accounts-state';
import { resetListEntities } from '@epicuro-next/state/list-entities';
import { resetProductReferenceEntities } from '@epicuro-next/state/list-product-reference-entities';
import {
  loadOpenedListProducts,
  selectOpenedList,
  setOpenedList,
} from '@epicuro-next/state/product-list-state';
import { setSelectedSite } from '@epicuro-next/state/site-state';
import { updateUserEntityImage } from '@epicuro-next/state/user-entities';
import {
  selectUser,
  uploadAvatarImageSuccess,
} from '@epicuro-next/state/user-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { filter, switchMap } from 'rxjs/operators';

import { initProductLists, resetProductListStore } from '../../actions';

@Injectable()
export class ResetEffects {
  constructor(private actions$: Actions, private store: Store) {}

  public resetProductListStore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setActiveAccount, setSelectedSite),
      switchMap(() => [
        resetProductListStore(),
        initProductLists(),
        resetProductReferenceEntities(),
      ]),
    ),
  );

  public resetAllEntities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(uploadAvatarImageSuccess),
      concatLatestFrom(() => [
        this.store.pipe(select(selectOpenedList)),
        this.store.pipe(select(selectUser)),
      ]),
      filter(
        ([_, list, currentUser]) =>
          isNonNullish(list) && isNonNullish(currentUser),
      ),
      switchMap(([{ url }, list, currentUser]) => [
        updateUserEntityImage({
          externalId: currentUser?.externalId as string,
          imageLink: url,
        }),
        resetProductListStore(),
        initProductLists(),
        resetListEntities(),
        setOpenedList({ id: list?.id as string }),
        loadOpenedListProducts({ samePage: true }),
      ]),
    ),
  );
}
